import React from 'react'
import { Button, Typography, useTheme, Paper, Box } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { Container } from '../../components'
import { StripeAccountStatus } from '../../hooks/useRent'
import { Routes } from '../../navigation/config/routes'
import StripeLogo from '../../assets/Stripe_Logo_0.svg'

interface Props {
    stripeAccountStatus?: StripeAccountStatus | null
}

/**
 * Rent gate when Stripe is not enabled. Setup lives on Integrations —
 * this page only explains the blocker and deep-links there.
 */
export const Onboarding = (props: Props) => {
    const theme = useTheme()
    const history = useHistory()
    const status = props.stripeAccountStatus

    const isInReview = status === 'in_review'
    const isRejected = status === 'rejected'

    return (
        <Container
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                maxWidth: 600,
                margin: '0 auto',
                padding: theme.spacing(2),
                marginBottom: theme.spacing(8),
            }}
        >
            <Paper
                elevation={3}
                style={{
                    padding: theme.spacing(4),
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <img
                    src={StripeLogo}
                    alt="Stripe"
                    style={{
                        height: 40,
                        marginBottom: theme.spacing(4),
                        width: 'auto',
                    }}
                />

                <Box textAlign="center">
                    <Typography
                        variant="h4"
                        gutterBottom
                        style={{
                            fontWeight: 600,
                            marginBottom: theme.spacing(3),
                        }}
                    >
                        {isInReview
                            ? 'Stripe account under review'
                            : isRejected
                            ? 'Stripe account needs attention'
                            : 'Stripe required for Rent'}
                    </Typography>

                    <Typography variant="body1" color="textSecondary" paragraph>
                        {isInReview
                            ? 'Your Stripe account is being reviewed. This usually takes 1–2 business days. You can check status on the Integrations page.'
                            : isRejected
                            ? "Stripe rejected this property's Connect account. Resume setup from Integrations or contact Stripe support."
                            : 'Rent payments use this property’s Stripe Connect account. Connect or finish setup under Integrations, then return here.'}
                    </Typography>

                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={() => history.push(Routes.manage.integrations)}
                        style={{
                            marginTop: theme.spacing(3),
                            padding: theme.spacing(1.5, 4),
                            fontSize: '1.1rem',
                            minWidth: 200,
                        }}
                    >
                        Go to Integrations
                    </Button>
                </Box>
            </Paper>
        </Container>
    )
}
